import { FunctionComponent, useState } from 'react'
import { NavigationItem } from '../types'
import { Text } from '../../../atoms/text'
import PopoverButton from '../../../molecules/popover-button'
import { trimSlashes } from '../../../../utils/links'
import { List, ItemButton, PopoverContent, PopoverItemButton } from '../shared/styles'
import { useLocation } from '@reach/router'
import { Link } from 'gatsby'

interface DesktopItemListProps {
  items: NavigationItem[]
}

const DesktopItemList: FunctionComponent<DesktopItemListProps> = ({ items }) => {
  const location = useLocation()
  const pathname = location.pathname
  const sanitizedPathname = trimSlashes(pathname)
  const [openedPopover, setOpenedPopover] = useState<string | null>(null)

  return (
    <List role="menubar">
      {items.map((item, itemIndex) => {
        return (
          <li key={`${item.title}_${itemIndex}`} role="none">
            {!('dropdownItems' in item) && (
              <ItemButton
                variant="ghost"
                as={Link}
                to={`${item.link}`}
                role="menuitem"
                aria-current={trimSlashes(item.link ?? '') === sanitizedPathname ? 'page' : undefined}
                data-active={`${trimSlashes(item.link ?? '') === sanitizedPathname}` || undefined}
                isSubdued={Boolean(openedPopover)}
              >
                <Text fontStyle="label-l">{item.title}</Text>
              </ItemButton>
            )}
            {'dropdownItems' in item && (
              <PopoverButton
                trigger={
                  <ItemButton
                    as={'span'}
                    variant="ghost"
                    trailingIcon="chevron-down"
                    gap="s"
                    data-active={
                      `${item.dropdownItems.some(child => trimSlashes(child.link ?? '') === sanitizedPathname)}` ||
                      undefined
                    }
                    isSubdued={Boolean(openedPopover) && openedPopover !== `${item.title}_${itemIndex}`}
                  >
                    <Text fontStyle="label-l">{item.title}</Text>
                  </ItemButton>
                }
                isOpen={`${item.title}_${itemIndex}` === openedPopover}
                onOpenChange={open => {
                  setOpenedPopover(open ? `${item.title}_${itemIndex}` : null)
                }}
                config={{ openingMode: 'hover', offset: 20 + 1, x: 0, closeOnClick: true }}
                blurConfig={{ isBlurEnabled: true, blurStyles: { top: 'var(--navigation-height)' } }}
              >
                <PopoverContent>
                  {item.dropdownItems.map((dropdwonItem, dropdwonIndex) => {
                    return (
                      <li key={`${dropdwonItem.title}_${dropdwonIndex}`} role="none">
                        <PopoverItemButton
                          variant="ghost"
                          as={Link}
                          to={`${dropdwonItem.link}`}
                          role="menuitem"
                          aria-current={trimSlashes(dropdwonItem.link ?? '') === sanitizedPathname ? 'page' : undefined}
                          data-active={`${trimSlashes(dropdwonItem.link ?? '') === sanitizedPathname}` || undefined}
                        >
                          <Text fontStyle="label-l">{dropdwonItem.title}</Text>
                        </PopoverItemButton>
                      </li>
                    )
                  })}
                </PopoverContent>
              </PopoverButton>
            )}
          </li>
        )
      })}
    </List>
  )
}

export { DesktopItemList }
